module.exports = __webpack_public_path__ + "img/2014.10.7bb0437b.png";